/* globals $:false */

import tmpl from '../templates/instance-field-file.dot';
import ui from '@cob/ui-genesis/cob.ui.js';
import utils from '@cob/ui-genesis/cob.utils.js';

const format = function (baseUri, filename){
    var _href = baseUri.trim();

    if (!baseUri.endsWith("/")) {
        _href += "/";
    }

    _href += encodeURIComponent(filename);

    return '<a class="link" target="_blank" href="' + _href + '">' + filename + '</a>';
};


// Component capable of handling only file fields
//
// args:
// * `baseUri`: the base uri to upload the file
// * `confs`: the field configuration
//
// confs:
// * `id`: the input attr id
// * `cssClasses`: A space separated list of css classes to add to the input
// * `readonly`: true or false. Defaults to false
// * `valueChanged(newValue)`: Invoked when a user changes the value,
// * `timeout`: The timeout in milliseconds allowed to upload a file. Defaults to 300000 (5m).
//
var File = function(core, baseUri, confs) {

    var supportFileDrop = (window.FileReader ? true : false);

    var _$html,
        _$fileInput,
        _$uploadButton,
        _$linkContainer,
        _$progressBar,
        _$removeFileLink,
        _lastValue;

    var _confs = {
        id: core.locallyUniqueId(),
        cssClasses: undefined,
        readonly: false,
        valueChanged: undefined,
        timeout: 300000
    };

    utils.extend(_confs, confs, true);

    var _setValue = function(value) {
        // We just want to notify
        // when the value changes.
        if (_lastValue !== value) {
            _lastValue = value;

            if(_$removeFileLink){
                _$removeFileLink.toggleClass("hidden", (_lastValue === undefined || _lastValue === null));
            }

            if (_confs.valueChanged) {
                _confs.valueChanged(value);
            }
        }
    };

    var _updateDownloadLink = function(filename) {
        _$linkContainer.html(format(baseUri, filename));
    };

    const _removeFile = function () {
        _$linkContainer.html("");
        _$html.find('.js-file-drop-target').removeClass("hidden");

        _setValue(undefined);
    };

    const _render = function() {
        _$html = $(tmpl({
            id: _confs.id,
            cssClasses: (_confs.cssClasses || ""),
            hasFile: (_lastValue !== undefined && _lastValue !== null),
            readOnly: _confs.readonly
        }));

        _$fileInput = _$html.find(".js-file-input");
        _$uploadButton = _$html.find(".js-upload-button");
        _$progressBar = _$html.find(".js-progress-bar");
        _$linkContainer = _$html.find(".js-link-container");
        _$removeFileLink = _$html.find(".js-remove-file");

        if (!_confs.readonly) {

            _$uploadButton.on('click', function() {
                _$fileInput.click();
            });

            _$removeFileLink.on('click', _removeFile);

            _$html.fileupload({
                dropZone: _$html.find('.js-file-drop-target'),
                pasteZone: _$html.find('.js-file-drop-target'),
                url: baseUri,
                timeout: _confs.timeout,
                forceIframeTransport: !supportFileDrop,
                replaceFileInput: false,
                dataType: "html",
                add: function(e, data) {
                    _$progressBar.progressbar({value: 0});
                    _$progressBar.removeClass('hidden');

                    data.submit();
                },
                done: function(e, data) {
                    var value = $(data.jqXHR.responseText).val();

                    _updateDownloadLink(value);
                    _setValue(value);
                },
                fail: function(e, data) {
                    ui.notification.showNotificationsFromRequest('error', data.jqXHR);
                },
                progress: function(e, data) {
                    _$progressBar.progressbar({value: (data.loaded * 100) / data.total});
                },
                always: function() {
                    _$progressBar.addClass('hidden');
                    _$html.find('.js-file-drop-target').addClass('hidden');
                }
            });
        }

        if (_lastValue) {
            _updateDownloadLink(_lastValue)
        }

        core.translate('cob.file-upload', _$html);

        return _$html;
    };

    var _clearError = function() {
        _$uploadButton.removeClass("error");
    };

    var _showError = function() {
        _$uploadButton.addClass("error");
    };

    var _destroy = function() {
        if (!_confs.readonly) {
            _$uploadButton.off('click');
            _$removeFileLink.off('click');
        }
    };

    return {
        render: _render,
        destroy: _destroy,

        disableSelf: function(){
           _$html.fileupload('disable');
           _$uploadButton.off('click');
           _$removeFileLink.off('click');
        },

        clearError: _clearError,
        showError: _showError,

        setValue: function(value) {
            if (_$fileInput) {
                _updateDownloadLink(value);
            }

            // Notify that this field has a new value because
            // I want to update the $auto.join and other fields...
            _setValue(value);
        },
        getValue: function() {
            return _lastValue !== null ? _lastValue : undefined;
        }
    }
};

export default File;
export { File, format };
